"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSchemaProperties = exports.ZapierProductSchema = exports.ProductSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const client_schema_1 = require("./client-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const smart_action_schema_1 = require("./smart-action-schema");
const ProductStatusEnum = zod_1.z.enum(["active", "deleted"]);
const ProductPaymentSchema = base_schema_1.BaseSchema.extend({
    payeeId: zod_1.z.string(),
    status: zod_1.z.literal("open"),
    title: zod_1.z.string().optional(),
    amount: zod_1.z.number().min(0),
    total: zod_1.z.number().min(0),
    currency: zod_1.z.string(),
    taxTypeId: zod_1.z.string().optional(),
    frequency: zod_1.z
        .object({
        interval: zod_1.z.enum(["week", "month"]),
    })
        .optional(),
});
exports.ProductSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.z.string(),
    slug: zod_1.z.string(),
    description: zod_1.z.string(),
    icon: zod_1.z.string(),
    status: ProductStatusEnum,
    smartActionTemplates: zod_1.z.array(smart_action_schema_1.SmartActionTemplateSchema).optional(),
    payment: ProductPaymentSchema,
});
exports.ZapierProductSchema = zod_1.z.object({
    title: zod_1.z.string().optional(),
    id: zod_1.z.string(),
    client: client_schema_1.ZapierClientSchema.optional(),
});
exports.ProductSchemaProperties = {
    collectionName: "products",
    deleteMode: schema_properties_interface_1.DeleteMode.InStatus,
};
//# sourceMappingURL=product-schema.js.map